/**
 * Logo slider: Swiper with Slick-matching breakpoints (1100 / 600).
 * Desktop (≥1100px): carousel runs only when slide count >= Items per row;
 * fewer logos show a static row (no slider). Tablet/mobile always use Swiper.
 */
(function () {
  var DESKTOP_MIN = 1100;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function parseConfig(el) {
    return {
      itemsDesktop: Math.max(1, parseInt(el.getAttribute('data-desktop'), 10) || 3),
      itemsTablet: Math.max(1, parseInt(el.getAttribute('data-tablet'), 10) || 4),
      itemsMobile: Math.max(1, parseInt(el.getAttribute('data-mobile'), 10) || 3),
      rewind: el.getAttribute('data-rewind') === 'true',
      autoplay: el.getAttribute('data-autoplay') === 'true',
      spaceBetween: parseInt(el.getAttribute('data-spacing'), 10) || 0,
    };
  }

  function slideCount(el) {
    return el.querySelectorAll('.swiper-slide').length;
  }

  function setMode(section, sliderEl, mode, cfg) {
    var count = slideCount(sliderEl);
    sliderEl.classList.remove('logo-slider--desktop-arrows', 'logo-slider--static-desktop');
    if (section) {
      section.classList.remove(
        'logo-slider-section--few-desktop',
        'logo-slider-section--desktop-arrows'
      );
    }

    if (mode === 'static-desktop') {
      sliderEl.classList.add('logo-slider--static-desktop');
      if (section) section.classList.add('logo-slider-section--few-desktop');
      return;
    }

    if (
      typeof window.innerWidth === 'number' &&
      window.innerWidth >= DESKTOP_MIN &&
      count >= cfg.itemsDesktop
    ) {
      sliderEl.classList.add('logo-slider--desktop-arrows');
      if (section) section.classList.add('logo-slider-section--desktop-arrows');
    }
  }

  function destroyIfAny(el) {
    if (el.swiper) {
      el.swiper.destroy(true, true);
    }
  }

  function initSwiper(el, cfg) {
    var paginationEl = el.querySelector('.logo-slider-pagination');
    var nextEl = el.querySelector('.logo-slider-next');
    var prevEl = el.querySelector('.logo-slider-prev');

    var options = {
      speed: 300,
      slidesPerView: cfg.itemsMobile,
      slidesPerGroup: 1,
      spaceBetween: cfg.spaceBetween,
      watchOverflow: true,
      roundLengths: true,
      rewind: cfg.rewind,
      autoplay: cfg.autoplay
        ? {
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      breakpoints: {
        600: {
          slidesPerView: cfg.itemsTablet,
        },
        1100: {
          slidesPerView: cfg.itemsDesktop,
        },
      },
    };

    if (paginationEl) {
      options.pagination = {
        el: paginationEl,
        clickable: true,
      };
    }
    if (nextEl && prevEl) {
      options.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };
    }

    return new window.Swiper(el, options);
  }

  function applySlider(el) {
    if (typeof window.Swiper === 'undefined') return;

    var cfg = parseConfig(el);
    var section = el.closest('.logo-slider-section');
    var count = slideCount(el);
    var w = window.innerWidth;

    destroyIfAny(el);

    if (count === 0) {
      setMode(section, el, 'swiper', cfg);
      return;
    }

    var staticDesktop = w >= DESKTOP_MIN && count < cfg.itemsDesktop;

    if (staticDesktop) {
      setMode(section, el, 'static-desktop', cfg);
      return;
    }

    setMode(section, el, 'swiper', cfg);
    var swiper = initSwiper(el, cfg);
    el.swiper = swiper;
  }

  function initAll() {
    document.querySelectorAll('[data-logo-slider]').forEach(applySlider);
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  }

  ready(function () {
    initAll();
    window.addEventListener('resize', onResize);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-logo-slider]')) {
      initAll();
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-logo-slider]').forEach(function (el) {
      destroyIfAny(el);
    });
  });
})();
